import { Directive, ElementRef, Input } from '@angular/core';
import { ItemBase } from '../../../models/item/item-base';
var PlaceholderDirective = /** @class */ (function () {
    function PlaceholderDirective(el) {
        this.el = el;
    }
    PlaceholderDirective.prototype.ngOnInit = function () {
    };
    PlaceholderDirective.prototype.ngOnChanges = function (changes) {
        if (changes.col) {
            this.setPlaceholder();
        }
    };
    PlaceholderDirective.prototype.setPlaceholder = function () {
        if (this.col.params && this.col.params.placeholder) {
            this.el.nativeElement.placeholder = this.col.params.placeholder;
        }
    };
    PlaceholderDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[placeholder]'
                },] }
    ];
    /** @nocollapse */
    PlaceholderDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    PlaceholderDirective.propDecorators = {
        col: [{ type: Input, args: ['placeholder',] }]
    };
    return PlaceholderDirective;
}());
export { PlaceholderDirective };
//# sourceMappingURL=placeholder.directive.js.map